<div class="annotated-text-container" #htmlContainer [innerHTML]="safeHtml"></div>